
import datatables from '../compat/datatables';

export default function () {

    datatables.addCallbacks({
	});
}